import TopSellersLeaderboard from '../features/analytics/TopSellersLeaderboard';

export default function TopSellersPage() {
  return (
    <div className="page">
      <header className="page-header">
        <div>
          <h1>En Çok Satanlar</h1>
          <p>En yüksek ciroyu ve adedi getiren ürünleri görselleştirin.</p>
        </div>
      </header>
      <section className="page-section">
        <TopSellersLeaderboard />
      </section>
    </div>
  );
}
